import React from 'react';
import { useDeveloperStore } from '@stores';
import { DeveloperAccessService } from '@src/api/services/developer/service';
import { toast } from 'react-toastify';

import { Button } from '@trussworks/react-uswds';
import TextInput from '@components/text-input/TextInput';

import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useForm, FormProvider } from 'react-hook-form';
import { ResponseStatuses } from '@src/utils/enums';

const schema = yup.object().shape({
  version: yup.string().required('Field is required'),
});

const ManageVersion = () => {
  const { bannerInfo } = useDeveloperStore();
  const { version } = bannerInfo;

  const defaultValues = {
    version: version ?? null,
  };

  const methods = useForm({
    defaultValues: defaultValues,
    resolver: yupResolver(schema),
    mode: 'onBlur',
    stateOptions: [],
  });
  const {
    formState: { isValid },
    watch,
    trigger,
  } = methods;

  const versionValue = watch('version');

  const handleSubmit = async () => {
    if (isValid) {
      const response = await DeveloperAccessService.updateVersion(versionValue);
      if (response.status === ResponseStatuses.Success) {
        DeveloperAccessService.getBannerInfo();
        toast.success('Successfully updated version');
      } else {
        toast.error('An error occurred while updating version');
      }
    } else {
      trigger();
      toast.error('Please fill out all required fields!');
    }
  };

  return (
    <FormProvider {...methods}>
      <div>
        <TextInput name='version' label='Version' placeholder={version} required style={{ width: '200px' }} />
        <Button title='Update Version' size='small' onClick={handleSubmit} style={{ marginTop: '1rem' }}>
          Update Version
        </Button>
      </div>
    </FormProvider>
  );
};

export default ManageVersion;
